import { computed } from "vue";
import axios from "axios";

import { store } from "@/store";

import { setCanvasJson } from "@/canvas-api/ConvertCanvas";

import { prepareArtwork } from "@/composables/usePrepareSaveArtwork";
import { getEditorUrlParam } from "@/composables/useParseURL";
import usePrintPreview from "@/composables/usePrintPreview";

import { CurrentLabel } from "@/types";

const editorParams = computed(() => store.getters.editorParams);
const userArtworkFetch = computed(() => store.getters.userArtworkFetch);
const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);
const currentLabelMaterialId = computed<CurrentLabel>(() => store.getters.currentLabelMaterialId);

const isRotated = computed<boolean>(() =>
  store.getters.canvasOrientation === "rotated" ? true : false
);
const getDefaultOrientation = computed<string>(() =>
  store.getters.currentLabel.width >= store.getters.currentLabel.height ? "landscape" : "portrait"
);
const currentOrientation = computed<string>(() =>
  isRotated.value
    ? getDefaultOrientation.value === "landscape"
      ? "portrait"
      : "landscape"
    : getDefaultOrientation.value
);

export default async (values: any = null): Promise<boolean> => {
  const labelGroup = await usePrintPreview();
  const canvasAsJSON = await setCanvasJson();

  if (labelGroup && canvasAsJSON) {
    const svg = await prepareArtwork(labelGroup, isRotated.value);

    try {
      const title =
        (values && values.title) ? values.title
          : userArtworkFetch.value.artwork && userArtworkFetch.value.artwork.title
          ? userArtworkFetch.value.artwork.title
          : "Blank";

      // prettier-ignore
      const data = {
        title,
        svg,
        id: null,
        width: currentLabel.value.width,
        height: currentLabel.value.shape_id === 10 || currentLabel.value.shape_id === 3 ? currentLabel.value.width : currentLabel.value.height,
        shape_id: currentLabel.value.shape_id,
        label_id: currentLabel.value.label_id,
        corners: currentLabel.value.corners,
        corner_radius: currentLabel.value.corner_radius,
        editor: "full",
        editorvue: "1",
        blank_editor: "0",
        material_id: currentLabelMaterialId.value ? currentLabelMaterialId.value : getEditorUrlParam("material_id").length ? getEditorUrlParam("material_id") : "1",
        rush_id: getEditorUrlParam("rush_id").length ? getEditorUrlParam("rush_id") : "4",
        product_id: editorParams.value.product_id,
        orientation: currentOrientation.value,
        json: canvasAsJSON,
      };

      if (userArtworkFetch.value.artwork) {
        data.id = userArtworkFetch.value.artwork.id;
      }

      if (!editorParams.value.postURL) {
        throw new Error("MISSING POST URL");
      } else {
        let postUrl = `${process.env.VUE_APP_API_URL}${editorParams.value.postURL}`;

        if (getEditorUrlParam("item_id").length) {
          postUrl = `${postUrl}?item_id=${getEditorUrlParam("item_id")}`;
        }

        const res = await axios.post(postUrl, data);

        if (!values || (values && !values.noRedirect))
          window.location.href = res.data["nextURL"];
      }
    } catch (e) {
      console.log(e);
    }
  }

  return false;
};
